/** Keep operator ordering when new links become available or permissions change. */
export function orderNavItems<T extends { to: string }>(
  items: T[],
  savedOrder: string[],
): T[] {
  const position = new Map(savedOrder.map((path, index) => [path, index]));
  const original = new Map(items.map((item, index) => [item.to, index]));
  return [...items].sort((a, b) => {
    const ai = position.get(a.to);
    const bi = position.get(b.to);
    if (ai !== undefined && bi !== undefined) return ai - bi;
    if (ai !== undefined) return -1;
    if (bi !== undefined) return 1;
    return (original.get(a.to) ?? 0) - (original.get(b.to) ?? 0);
  });
}
